import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API =
  ApiDefinition['/e-signature-requests/{eSignatureRequestId}/e-signature-signers/{eSignatureSignerId}']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateESignatureSignerForRequest = async ({
  eSignatureRequestId,
  eSignatureSignerId,
  ...body
}: Input): Promise<Output> => {
  const response = await noodleApiClient.put(
    `/e-signature-requests/${eSignatureRequestId}/e-signature-signers/${eSignatureSignerId}`,
    body,
  );
  return response.data;
};

export default updateESignatureSignerForRequest;
